var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.685,
    height: 37.685,
    viewBox: "0 0 37.685 37.685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    transform: "translate(0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M29.956,22.229a7.719,7.719,0,0,0-1.845.223L15.234,9.574A7.728,7.728,0,0,0,5.015.493a1.1,1.1,0,0,0-.392,1.814L6.845,4.529,6.537,6.538l-2.009.308L2.306,4.624a1.1,1.1,0,0,0-1.814.392A7.729,7.729,0,0,0,9.574,15.235L22.451,28.112A7.728,7.728,0,0,0,32.67,37.193a1.1,1.1,0,0,0,.392-1.814L30.84,33.157l.308-2.009,2.009-.308,2.222,2.222a1.1,1.1,0,0,0,1.814-.392,7.728,7.728,0,0,0-7.236-10.442Z",
    transform: "translate(0)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M393.936,9.108l3.123-3.123a1.1,1.1,0,0,0,0-1.561l-4.1-4.1a1.1,1.1,0,0,0-1.561,0l-3.123,3.123Z",
    transform: "translate(-359.698 -0.001)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M2.967,401.535.092,408.12a1.1,1.1,0,0,0,1.454,1.454L8.13,406.7Z",
    transform: "translate(0.001 -371.981)",
    fill: "#1a8fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(4.277 5.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M0,0H9.353V8H0Z",
    transform: "translate(16.123 6.612) rotate(-45)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M0,0H10.382V8H0Z",
    transform: "translate(0 22.733) rotate(-45)",
    fill: "#1a8fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.0b69be51f262b1be273c3963ac90f758.svg";
export { ForwardRef as ReactComponent };